import { render, staticRenderFns } from "./untactViewPage.vue?vue&type=template&id=04dc9012&scoped=true&"
import script from "./untactViewPage.vue?vue&type=script&lang=js&"
export * from "./untactViewPage.vue?vue&type=script&lang=js&"
import style0 from "./untactViewPage.vue?vue&type=style&index=0&id=04dc9012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dc9012",
  null
  
)

export default component.exports